import React from "react";
import { Container, Info, Indicator, Content, TitleStepper } from "./style";
//Types
import { IStepProps } from "./interface";
const Step = (props: IStepProps) => {
  const { active, indicator } = props;
  return (
    <Container>
      <Indicator>
        <Info active={active}>
          <Content active={active}></Content>
        </Info>
      </Indicator>
      <TitleStepper>{indicator}</TitleStepper>
    </Container>
  );
};

export default Step;
